import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

interface Props {
  currentStepIndex: number;
  maxSteps: number;
}

const CheckoutProgressBarWrapper = styled.div`
  width: 100%;
  height: ${rem(4)};
  background-color: ${({ theme }) => theme.palette.neutral.default.six};
  position: absolute;
  bottom: 0;
  left: 0;
`

const ProgressBarContent = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.default.one};
  height: 100%;
  transition: width 0.5s ease-in-out;
`

function CheckoutProgressBar({ currentStepIndex, maxSteps }: Props) {
  const progressWidth = useMemo(() => {
    const percent = Math.round(((currentStepIndex + 1) / maxSteps) * 100)
    return `${percent}%`
  }, [currentStepIndex, maxSteps])

  return <CheckoutProgressBarWrapper>
    <ProgressBarContent style={{ width: progressWidth }} />
  </CheckoutProgressBarWrapper>
}

export default CheckoutProgressBar
